import * as yup from "yup";

export const createIndustrySchema = yup.object().shape({
  name: yup.string().required(),
  description: yup.string().required(),
});
